import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import Home from '../../Components/Home/Home'
import { useEffect } from 'react'
import "./About.css"
import Loader from "../../Components/Loader/Loader"
function Loaded(){
  document.querySelector(".Loader").style.display = "none";
  document.querySelector(".App-3").style.display = "block";
}
const About = () => {
  useEffect(() => {
    setTimeout(Loaded,1000);
  }, []);
  return (
    <>
    <Loader></Loader>
    <div className='App-3'>
      <Navbar></Navbar>
      <Home></Home>
      <Footer></Footer>
    </div>
    </>
  )
}

export default About
